const photocamara = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.17 5L9 3H15L16.83 5H20C21.1 5 22 5.9 22 7V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V7C2 5.9 2.9 5 4 5H7.17ZM7 13C7 15.76 9.24 18 12 18C14.76 18 17 15.76 17 13C17 10.24 14.76 8 12 8C9.24 8 7 10.24 7 13ZM15.2 13C15.2 14.7674 13.7674 16.2 12 16.2C10.2327 16.2 8.80005 14.7674 8.80005 13C8.80005 11.2327 10.2327 9.80005 12 9.80005C13.7674 9.80005 15.2 11.2327 15.2 13Z" fill="black" />
  </svg>
);
export default photocamara;
